import _ from 'lodash';

import MetricChartModel from './MetricChartModel';
import MultiValueMetricChartModel from './MultiValueMetricChartModel';
import PopulationGrowthModel from './PopulationGrowthModel';
import PopulationChartModel from './PopulationChartModel';

export default function createChartModel(dataRecords, parent, options) {
    const chartType = _.camelCase(options.chartType);
    if (chartType === 'populationGrowth') {
        return new PopulationGrowthModel(dataRecords, parent, options);
    }
    if (chartType === 'populationPyramid') {
        return new PopulationChartModel(dataRecords, parent, options);
    }
    if (
        chartType === 'deprivation'
        || chartType === 'deprivationType'
        || chartType === 'multiBulletChart'
        || chartType === 'multiDotPlot'
    ) {
        return new MultiValueMetricChartModel(dataRecords, parent, options);
    }
    return new MetricChartModel(dataRecords, parent, options);
}
